import * as yup from "yup";

type ValidatorField = {
  htmlType?: string;
  dbType?: string;
  title?: string;
};

type SupportedSchema =
  | yup.StringSchema
  | yup.BooleanSchema
  | yup.NumberSchema
  | yup.DateSchema;

const yupTypeValidator = (item: ValidatorField): SupportedSchema | undefined => {
  const label = item.title ?? "";

  if (item.htmlType === "selectobj" || item.htmlType === "radioobj") {
    return yup.string().label(label).required();
  } else if (
    item.dbType === "string" ||
    item.dbType === "varchar" ||
    item.dbType === "datetime"
  ) {
    return yup.string().label(label).required();
  } else if (item.dbType === "bool" || item.dbType === "bit") {
    return yup.boolean().label(label).required();
  } else if (
    item.dbType === "int" ||
    item.dbType === "bigint" ||
    item.dbType === "decimal" ||
    item.dbType === "money"
  ) {
    return yup.number().label(label).required();
  } else if (item.dbType === "date") {
    return yup.date().label(label).required();
  }
};

export default yupTypeValidator;
